import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
//import Home from './pages/Home';
import ComingSoon from './pages/ComingSoon';
import News from './pages/News';
import History from './pages/History';
import Teams from './pages/Teams';
import WhatsOn from './pages/WhatsOn';
import Contact from './pages/Contact';
import Eagle from './pages/Eagle';
import Lotto from './pages/Lotto';

// Set this to false when ready to launch the site
const SITE_IS_READY = false;

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ComingSoon />} />
        {SITE_IS_READY ? (
          <>
            <Route path="/news" element={<News />} />
            <Route path="/history" element={<History />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/lotto" element={<Lotto />} />
            <Route path="/whats-on" element={<WhatsOn />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/eagle" element={<Eagle />} />
          </>
        ) : null}
        {/* Catch-all route: redirect all other paths to coming soon */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
